import React from 'react'
import styled from 'styled-components'

const PhotosContainer = styled.div`
  width: 320px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  padding-right: 0.5rem;
  align-content: start;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.4);
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.6);
    }
  }
`

const PhotoItem = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 0.25rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`

const NoPhotosMessage = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.75rem;
  text-align: center;
  padding: 1rem;
`

interface PhotosListProps {
  signedUrls: string[]
}

export const PhotosList: React.FC<PhotosListProps> = ({ signedUrls }) => {
  return (
    <PhotosContainer>
      {signedUrls.length > 0 ? (
        signedUrls.map((url: string, idx: number) => (
          <PhotoItem key={idx} src={url} alt={`Screenshot ${idx + 1}`} />
        ))
      ) : (
        <NoPhotosMessage>No photos available</NoPhotosMessage>
      )}
    </PhotosContainer>
  )
}
